
















import { i18n } from '@/i18n';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { windowHelper } from '@tencent/ppd-base-libs';

/**
 * 加载数据失败
 */
@Component
export default class WeCouponsContentLoadFail extends Vue {
  /** 是否空数据 */
  @Prop({ default: false }) public empty!: boolean;
  /** 是否数据加载失败 */
  @Prop({ default: false }) public error!: boolean;
  @Prop({ default: '' }) public inputTips!: string;
  @Prop({ default: false }) public showMoreLink!: boolean;
  /** 是否搜索时数据为空 */
  @Prop({ default: false }) public emptySearch!: boolean;


  i18n = i18n;

  get isshowEmpty() {
    return this.empty || this.emptySearch;
  }

  get emptyIconClass() {
    if (this.emptySearch) {
      return 'icon-search';
    }
    return this.error ? 'icon-error' : 'icon-empty';
  }
  get tips() {
    if (this.inputTips) {
      return this.inputTips;
    }
    if (this.error) {
      return this.empty ? i18n('系統繁忙，請稍候再試。') : i18n('網絡繁忙，嘗試刷新');
    }
    if (this.emptySearch) {
      return i18n('未找到相關結果，換個商戶名稱試試啦');
    }
    if (this.empty) {
      return i18n('更多優惠敬請期待');
    }
    return '';
  }

  get isShow() {
    return this.empty || this.error || this.emptySearch;
  }
  /**
   * 刷新重试
   */
  handleRefresh() {
    if (this.error) {
      this.$emit('refresh');
    }
  }
  clickMore() {
    windowHelper.redirect('https://prom.wechatpay.com.hk/discount-center/coupon_home.shtml#/weCoupons/couponList/class0', 300);
  }
}
